export default function featuresReducer(state = {}, action) {
  switch (action.type) {
  case 'SYSTEM_MESSAGE_LOADED':
  case 'FEATURES_LOADED': {
    return {
      ...state,
      ...action.payload
    };
  }
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/featuresReducer.js